enum EModulePhaseTrackStatus {
    OnTime = "onTime",
    Late = "late",
    NotStarted = "notStarted"
}

export { EModulePhaseTrackStatus }
